'use strict';
export class QuoteHTML {
    constructor(token) {
        this.token = token;
    }
    render() {
        const paragraphs = this.token.value
            .replace(/^>\s?/gm, "")
            .split("\n");
        const paragraphsHtml = paragraphs
            .map((text) => `<p class="md-quote-p">${text}</p>`.trim())
            .join("");
        return `<div>${paragraphsHtml}</div>`;
    }
}
